import type { AppModule } from "../types";
import { s } from "./strings";

const page = (path: string, load: () => Promise<{ Component: React.ComponentType }>, title: string = s.pageTitle) => ({
  path,
  handle: { title },
  lazy: load,
});

export const reportsOtherModule: AppModule = {
  name: "reports-other",
  routes: {
    shell: [
      page("/reports/weekly", () => import("./pages/WeeklyPage").then((m) => ({ Component: m.WeeklyPage }))),
      page("/reports/shared", () => import("./pages/SharedListPage").then((m) => ({ Component: m.SharedListPage }))),
      page("/reports/team/attendance", () =>
        import("./pages/AttendancePage").then((m) => ({ Component: m.AttendancePage })),
      ),
      page("/reports/team/assignments", () =>
        import("./pages/AssignmentsPage").then((m) => ({ Component: m.AssignmentsPage })),
      ),
      page(
        "/activity/audit-log",
        () => import("./pages/AuditLogPage").then((m) => ({ Component: m.AuditLogPage })),
        s.activityTitle,
      ),
    ],
    "shared-report": [
      page("/shared/:sharedReportId", () =>
        import("./pages/SharedViewerPage").then((m) => ({ Component: m.SharedViewerPage })),
      ),
    ],
  },
};
